document.addEventListener('DOMContentLoaded', function () {
    // faq-questionの処理
    document.querySelectorAll('.faq-question').forEach(question => {
        question.addEventListener('click', function () {
            const answer = this.nextElementSibling;
            const iconPlus = this.querySelector('.plus');
            const iconMinus = this.querySelector('.minus');

            answer.classList.toggle('open');
            if (answer.classList.contains('open')) {
                answer.style.maxHeight = answer.scrollHeight + "px";
                iconPlus.style.display = 'none';
                iconMinus.style.display = 'block';
            } else {
                answer.style.maxHeight = "0";
                iconPlus.style.display = 'block';
                iconMinus.style.display = 'none';
            }
        });
    });

    // smooth-scrollの処理
    const anchors = document.querySelectorAll('.smooth-scroll');
    if (anchors.length > 0) {
        anchors.forEach(anchor => {
            anchor.addEventListener("click", function (e) {
                e.preventDefault(); // デフォルトの挙動（ページ遷移）をキャンセル
                const targetId = this.getAttribute("href").replace("#", "");
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    window.scrollTo({
                        top: targetElement.getBoundingClientRect().top + window.pageYOffset - 80,
                        behavior: "smooth"
                    });
                }
            });
        });
    }

    // Modalの処理
    const modal = document.getElementById('videoModal');
    const btnOpen = document.getElementById('modalBtn');
    const btnClose = document.querySelector('.close');
    let originalBodyPaddingRight = null;
    let scrollBarWidth = 0;

    function getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
    }

    function fixBody() {
        originalBodyPaddingRight = document.body.style.paddingRight;
        scrollBarWidth = getScrollbarWidth();
        document.body.style.paddingRight = `${scrollBarWidth}px`;
        document.body.classList.add('stop-scrolling');
    }

    function resetBody() {
        document.body.style.paddingRight = originalBodyPaddingRight;
        document.body.classList.remove('stop-scrolling');
    }

    function openModal() {
        fixBody();
        modal.style.display = 'block';
        modal.classList.add('modal-open');
    }

    function closeModal() {
        resetBody();
        modal.style.display = 'none';
        modal.classList.remove('modal-open');
    }

    if (btnOpen) {
        btnOpen.addEventListener('click', openModal);
    }
    if (btnClose) {
        btnClose.addEventListener('click', closeModal);
    }

    // fadeInSectionsの処理
    const fadeInSections = document.querySelectorAll('.fade-in-section');
    if (fadeInSections.length > 0) {
        const appearOnScroll = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            });
        }, {
            threshold: 0.2,
            rootMargin: "0px 0px -100px 0px" // ビューポートの下から100pxの位置でトリガー
        });

        fadeInSections.forEach(section => {
            appearOnScroll.observe(section);
        });
    }

    // smooth-scrollの処理
    let lastScrollTop = 0;  // 最後に記録されたスクロール位置
    let targetScroll = 0;  // 目標スクロール位置
    let currentScroll = 0;  // 現在のスクロール位置

    const waters = document.querySelectorAll('.water');
    if (waters.length > 0) {
        waters.forEach(water => {
            water.initialTop = parseInt(window.getComputedStyle(water).top, 10); // 初期位置を取得
        });

        window.addEventListener('scroll', function () {
            targetScroll = window.pageYOffset || document.documentElement.scrollTop;
        });

        function smoothScroll() {
            // 現在のスクロール位置を目標に近づける
            currentScroll += (targetScroll - currentScroll) * 0.125;
            waters.forEach(water => {
                const speed = parseFloat(water.dataset.speed);
                const offset = (currentScroll - lastScrollTop) * speed;
                water.style.transform = `translateY(${offset}px)`;
            });
            lastScrollTop = currentScroll;
            requestAnimationFrame(smoothScroll);
        }

        requestAnimationFrame(smoothScroll);
    }

    // readmoreの処理
    var targets = document.querySelectorAll('.readmore');
    var mores = document.querySelectorAll('.more');

    targets.forEach(function (target) {
        var readmoreInner = target.querySelector('.readmore_inner');

        // 一時的に非表示要素を表示して高さを取得する
        var originalDisplay = readmoreInner.style.display;
        readmoreInner.style.display = 'block'; // 要素を一時的に表示
        var initialHeight = readmoreInner.scrollHeight; // 要素の完全な高さを取得
        readmoreInner.style.display = originalDisplay; // 元の表示状態に戻す

        var more = target.nextElementSibling;

        console.log('Initial Height:', initialHeight); // デバッグ用ログ

        if (initialHeight > 200) { // 200px以上ならアコーディオン処理を適用
            target.classList.add('hide');

            more.addEventListener('click', function () {
                var readmore = this.previousElementSibling;
                var morespan = this.querySelector('span');

                if (this.classList.contains('close')) {
                    this.classList.remove('close');
                    readmore.style.maxHeight = '200px';
                    readmore.classList.add('hide');
                    readmore.classList.remove('expanded');
                    morespan.textContent = 'もっと見る';
                    console.log('Closed, max height: 200px'); // デバッグ用ログ
                } else {
                    readmore.style.maxHeight = '3000px'; // max-heightを3000pxに指定
                    readmore.classList.remove('hide');
                    readmore.classList.add('expanded');
                    this.classList.add('close');
                    morespan.textContent = '閉じる';
                    console.log('Opened, max height: 3000px'); // デバッグ用ログ
                    setTimeout(() => {
                        this.style.display = 'none';
                        console.log('More button hidden after 100ms'); // デバッグ用ログ
                    }, 100);
                }
            });
        } else {
            var morespan = more.querySelector('span');
            morespan.parentNode.removeChild(morespan);
            console.log('Morespan removed due to insufficient height.'); // デバッグ用ログ
        }
    });
});
